export default __webpack_public_path__ + "static/award-1-pe-174577925eaafbf31651893bbca11ec0.png";